import React from 'react';
import { Badge } from 'react-bootstrap';

import { DateTimeService } from 'src/services/DateTimeService';

import { OrderCartStatus } from '../../../providers';

export function StatusBadge(props: { date?: null | string; status?: null | OrderCartStatus }) {
  if (props.status == null) return null;

  return (
    <Badge variant={STATUS_BADGE_VARIANTS[props.status]} className="mt-2">
      {STATUS_BADGE_TEXT[props.status]} {props.date && DateTimeService.format(props.date, 'DD.MM.YYYY')}
    </Badge>
  );
}

const STATUS_BADGE_TEXT: Record<OrderCartStatus, string> = {
  [OrderCartStatus.Created]: 'Создана',
  [OrderCartStatus.Confirmed]: 'Подтверждена',
  [OrderCartStatus.Completed]: 'Выполнена',
  [OrderCartStatus.Canceled]: 'Отменена',
  [OrderCartStatus.Unknown]: 'Статус неизвестен',
};

const STATUS_BADGE_VARIANTS: Record<OrderCartStatus, string> = {
  [OrderCartStatus.Created]: 'primary',
  [OrderCartStatus.Confirmed]: 'primary',
  [OrderCartStatus.Completed]: 'success',
  [OrderCartStatus.Canceled]: 'danger',
  [OrderCartStatus.Unknown]: 'warning',
};
